import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axiosInstance from "../common/api";
import { filterOption, formatDateTime } from "../common/common";
import { useNavigate, useParams } from "react-router-dom";

export default function EditAttendanceRawRecord() {
    const [form] = Form.useForm();
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        axiosInstance.get(`attendanceRawRecord/${id}`).then(({ data }) =>
            form.setFieldsValue({
                ...data,
                employee: data.employee.fullName,
                timestamp: dayjs.utc(data.timestamp).tz(dayjs.tz.guess()),
            }),
        );
    }, []);

    const onFormFinish = (form) => {
        const formData = {
            timestamp: dayjs.utc(form.timestamp.tz(dayjs.tz.guess())).format(),
            src: "web",
        };
        axiosInstance.put(`attendanceRawRecord/${id}`, formData)
        .then(() => navigate(-1))
    };

    return (
        <Form
            id="editAttendanceRawRecordForm"
            form={form}
            layout="vertical"
            onFinish={onFormFinish}
        >
            <Form.Item name={"employee"} label="Dipendente">
                <Input disabled/>
            </Form.Item>
            <Form.Item name={"timestamp"} label="Data e ora">
                <DatePicker format="DD/MM/YYYY HH:mm" showTime />
            </Form.Item>

            <Form.Item>
                <Button htmlType="submit" type="primary">
                    Conferma
                </Button>
            </Form.Item>
        </Form>
    );
}
